












































import { Component, Vue } from "vue-property-decorator";
import { Icon } from "vant";
@Component({
  components: {
    [Icon.name]: Icon
  }
})
export default class TransferIntoIndex extends Vue {
  cardAlreadyBound = false;

  created() {
    this.getList();
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get bankAreaList() {
    return [
      // {
      //   id: 0,
      //   name: this.$t("funds.into.bankList[0]"),
      //   mark: this.$t("funds.into.bankList[2]")
      // },
      {
        id: 1,
        name: this.$t("funds.into.bankList[1]"),
        mark: this.$t("funds.into.bankList[3]")
      }
    ];
  }
  get warnText() {
    return `* ${this.$t("funds.into.domText[1]")}`;
  }

  /**
   * 跳转到对应的主页
   * @param item {Object} 列表项数据
   */
  jumpToAreaBank(item) {
    if (!this.cardAlreadyBound) {
      //是否已经绑定银行卡
      this.$dialog
        .confirm({
          title: "提示",
          message: "请先绑定本人银行卡",
          confirmButtonText: "立即绑定",
          ["className" as any]: this.bgColor !== 'white-theme' ? 'black-theme-dialog' : ''
        })
        .then(() => {
          this.$router.push({ name: "bank-card-list" });
        })
        .catch(() => {});
      return;
    }
    switch (item.id) {
      case 0:
        this.$router.push({
          name: "transfer-into-inland",
          query: { ...this.$route.query, from: "inland" }
        });
        break;
      case 1:
        this.$router.push({
          name: "transfer-into-hk-index",
          query: { ...this.$route.query, from: "hk" }
        });
        break;
      default:
        return;
    }
  }
  // 获取银行卡列表
  getList() {
    (this as any).$apis
      .getBankList()
      .then(res => {
        this.cardAlreadyBound = res != "" && res.length > 0;
      })
      .catch(() => {});
  }
}
